module.exports = __webpack_public_path__ + "static/media/image38.4be11449.jpg";